
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 28","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.75 2C12.781 2 12 2.781 12 3.75V14h-.5V5.75c0-.969-.781-1.75-1.75-1.75S8 4.781 8 5.75V18l-2.406-3.203A1.999 1.999 0 004 14c-1.109 0-2 .906-2 2 0 .438.141.859.406 1.203l6 8c.375.5.969.797 1.594.797h10.75a1.52 1.52 0 001.484-1.219l1.188-6.328c.047-.297.078-.609.078-.922V9.75c0-.969-.781-1.75-1.75-1.75S20 8.781 20 9.75V14h-.5V5.75c0-.969-.781-1.75-1.75-1.75S16 4.781 16 5.75V14h-.5V3.75c0-.969-.781-1.75-1.75-1.75zm0-2c1.406 0 2.703.797 3.344 2.063A3.11 3.11 0 0117.75 2a3.76 3.76 0 013.75 3.75v.266c2.172-.125 4 1.547 4 3.734v7.781c0 .438-.047.875-.125 1.297l-1.188 6.312a3.487 3.487 0 01-3.437 2.859H10a4.07 4.07 0 01-3.203-1.594l-6-8A4.041 4.041 0 010 15.999c0-2.203 1.781-4 4-4 .656 0 1.453.156 2 .531V5.749a3.76 3.76 0 013.75-3.75c.219 0 .438.016.656.063A3.755 3.755 0 0113.75-.001z"}})])
          )
        }
      }
    